<template>
  <div v-rect-loading="loading" class="question-list">
    <TableList
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #status="{ row, data }">
        <el-switch :value="data" @change="onEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { ONBOARDING_QUESTION_TYPE, ONBOARDING_QUESTION_SCOPED_TYPE } from '@/constant/common'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      questionType: ONBOARDING_QUESTION_TYPE,
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.company.onboarding.label.questionName'),
          dataKey: 'content',
          formatter: (data, row) => {
            return row[`content_${this.previewLocale}`]
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.questionType'),
          dataKey: 'type',
          formatter: (data) => {
            const i18nKey = this.questionType[data].i18nKey
            return this.$t(i18nKey)
          }
        },
        {
          label: this.$t('admin.company.onboarding.label.questionStatus'),
          dataKey: 'status',
          slotName: 'status'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          isShow: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('onboardingManagement', ['searchQuestion', 'updateQuestion']),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchQuestion()
        if (resp && resp.questions) {
          this.listData = _.chain(resp.questions)
            .map(item => {
              return {
                ...item,
                status: item.status === 1
              }
            })
            .orderBy(['status'], ['desc'])
            .value()
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push('/v-admin/onboarding-management/question/add')
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/onboarding-management/question/edit/${rowData.id}`)
    },
    async onEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateQuestion(statusData)
        if (resp) {
          rowData.status = statusData.change_status
          if (ONBOARDING_QUESTION_SCOPED_TYPE.includes(rowData.type)) {
            _.forEach(this.listData, item => {
              if (item.scope === rowData.scope) {
                item.status = statusData.change_status
              }
            })
          }
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-list {
  .question-type {
    width: 200px;
  }

  .keyword {
    width: 250px;
  }

  .status-icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: url($baseDomain + 'static/images_en/img_grey.png') no-repeat;
    vertical-align: middle;

    &.is-active {
      background: url($baseDomain + 'static/images_en/img_green.png') no-repeat;
    }
  }
}
</style>
